import { render, staticRenderFns } from "./MyAttention.vue?vue&type=template&id=481a72d0&scoped=true"
import script from "./MyAttention.vue?vue&type=script&lang=js"
export * from "./MyAttention.vue?vue&type=script&lang=js"
import style0 from "./MyAttention.vue?vue&type=style&index=0&id=481a72d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a72d0",
  null
  
)

export default component.exports